import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID;
const dataset = process.env.REACT_APP_SANITY_DATASET || "production";
const apiVersion = process.env.REACT_APP_SANITY_API_VERSION || "2024-01-01";

export const isSanityConfigured = Boolean(projectId);

const clientConfig = {
  projectId,
  dataset,
  apiVersion,
};

// Live API — no CDN cache, so published posts appear immediately.
export const sanityClient = isSanityConfigured
  ? createClient({ ...clientConfig, useCdn: false })
  : null;

// CDN client for images only (images rarely need instant invalidation).
const cdnClient = isSanityConfigured
  ? createClient({ ...clientConfig, useCdn: true })
  : null;

const builder = cdnClient ? imageUrlBuilder(cdnClient) : null;

export const urlFor = (source) => (builder ? builder.image(source) : null);
